export default __webpack_public_path__ + "static/media/camera_grey.208d7b52.svg";